import { render, staticRenderFns } from "./rate-points.vue?vue&type=template&id=0aefea5a&scoped=true"
import script from "./rate-points.vue?vue&type=script&lang=js"
export * from "./rate-points.vue?vue&type=script&lang=js"
import style0 from "./rate-points.vue?vue&type=style&index=0&id=0aefea5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefea5a",
  null
  
)

export default component.exports